module.exports = __webpack_public_path__ + "img/3922713_orig.f9a8929d.png";